import { Navigate, Outlet } from "react-router";

const PrivateRoutes = () => {
  const verificarUsuarioLogado = () => {
    const usuario_local_info = localStorage.getItem("usuario_local_info");
    if (usuario_local_info) {
      return true;
    }
  };
  return verificarUsuarioLogado() ? <Outlet /> : <Navigate to={"/auth"} />;
};

export default PrivateRoutes;
